import { Controller, useFormContext } from 'react-hook-form';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Input } from 'ui/input/Input';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { Form } from 'ui/form/Form';
import { usePermissions } from 'hooks/usePermissions/usePermissions';

import { CopyGroupProps, CopyGroupFormBody } from './CopyGroup.types';

export const CopyGroup = ({ onSubmit, onModalClose, onModalOpen, isModalOpen, isLoading }: CopyGroupProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useFormContext<CopyGroupFormBody>();

  return (
    <>
      <ActionButton type="copy" onClick={onModalOpen} disabled={!perms?.UPR_GRUPOWE?.edit} />

      <ActionModal
        header={formatMessage({ id: AppMessages['group.copy.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={!isValid || isLoading}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['group.copy.submitButton'] })}
      >
        <Form.Grid>
          <Controller
            name="idGrupy"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['group.details.id'] })}
                placeholder={formatMessage({ id: AppMessages['group.details.id.placeholder'] })}
                errorMessage={error?.message}
                required
              />
            )}
          />
          <Controller
            name="nazwa"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['group.details.groupName.label'] })}
                placeholder={formatMessage({ id: AppMessages['group.details.groupName.placeholder'] })}
                errorMessage={error?.message}
                required
              />
            )}
          />

          <Controller
            name="opis"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['group.details.description.label'] })}
                placeholder={formatMessage({ id: AppMessages['group.details.description.placeholder'] })}
                errorMessage={error?.message}
              />
            )}
          />
        </Form.Grid>
      </ActionModal>
    </>
  );
};
